import React from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Key } from 'ts-key-enum';

import Label from 'components/general/Label';

import styles from './Toggle.scss';

type OwnProps = {
  value: boolean | null | undefined;
  disabled?: boolean;
  text?: string | React.ReactNode;
  description?: string;
  style?: React.CSSProperties;
  className?: string;
  onChange: (value: boolean) => any;
  interfaceStyle?: 'light' | 'dark';
  doTranslate?: boolean;
  testId?: string;
  mt?: number;
  mb?: number;
  TooltipComponent?: React.ReactNode;
  valuetestId?: string;
};

type Props = OwnProps;

export default function Toggle({
  text,
  description,
  disabled = false,
  doTranslate = false,
  value,
  testId,
  onChange,
  mt,
  mb,
  className,
  style,
  interfaceStyle = 'light',
  TooltipComponent,
  valuetestId,
}: Props) {
  const { t } = useTranslation();

  return (
    <label
      className={cx(styles.container, className)}
      style={style}
      data-toggle-disabled={disabled}
      data-interface-style={interfaceStyle}
      data-margin-top={mt}
      data-margin-bottom={mb}
      role="button"
      onClick={() => onChange(!value)}
      onKeyDown={e => e.key === Key.Enter && onChange(!value)}
      data-test={testId || text}
      tabIndex={0}
    >
      <div
        data-test={valuetestId || 'toggle-value'}
        className={styles.switchBackground}
        data-toggle-status={value}
      >
        <span className={styles.switchButton} data-toggle-status={value} />
      </div>
      <div className={styles.textContainer}>
        {text && (
          <Label
            TooltipComponent={TooltipComponent}
            disabled={disabled}
            className={styles.text}
            mt={0}
            as="span"
          >
            {doTranslate && typeof text === 'string' ? t(text) : text}
          </Label>
        )}
        {description && (
          <span
            className={styles.description}
            data-description-disabled={disabled}
          >
            {doTranslate ? t(description) : description}
          </span>
        )}
      </div>
    </label>
  );
}
